<template>
  <pt-active-sign class="pt-active-sign__withData"></pt-active-sign>
</template>

<script>
import PtActiveSign from './index'
export default {
  name: 'pt-active-sign__withData',
  components: {
    'pt-active-sign': PtActiveSign
  }
}
</script>
